import { request } from '@/utils/request'
const MajorAccountAreaManageService = {
  state: {},

  mutations: {},

  actions: {
    // 大客户区域分页
    GetAllRegion({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('Equipment/Region/GetAllRegion', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 保存大客户区域
    SaveRegion({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post('Equipment/Region/SubmitForm?keyValue=' + params.keyValue, params.formData).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 删除大客户区域
    DeleteRegion({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post('Equipment/Region/DeleteByObjectID', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
export default MajorAccountAreaManageService
